import { render, staticRenderFns } from "./PerfilRotaPage.vue?vue&type=template&id=4e5d528c"
import script from "./PerfilRotaPage.vue?vue&type=script&lang=js"
export * from "./PerfilRotaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports